module.exports = __webpack_public_path__ + "static/img/copy_friend.d02ead2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copy_friend.svg
// module id = Ca+7
// module chunks = 2